import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterLimitLevel"
    ,pure: false
})
export class FilterLimitLevel implements PipeTransform {
    transform(items : any[],filter:number) {
        if(!items || !filter){
            return items;
        }

        return items.filter((val,idx) => {
            return val.limitLevel >= filter;
        });
    }
}